<template>
  <div id="Heating" class="form">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.heating.title") }}</div>
      <div class="container inline bottom">
        <div
          class="frame secondary content-centered"
          :class="{active: heating === 'elec'}"
          @click="heating = 'elec'"
        >
          <h4>{{ $t("elec") }}</h4>
          <SvgIcon icon="elec" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
        <div
          class="frame secondary content-centered"
          :class="{active: heating === 'gas'}"
          @click="heating = 'gas'"
        >
          <h4>{{ $t("gas") }}</h4>
          <SvgIcon icon="gas" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
        <div
          class="frame secondary content-centered"
          :class="{active: heating === 'heat_pump'}"
          @click="heating = 'heat_pump'"
        >
          <h4>{{ $t("heat_pump") }}</h4>
          <SvgIcon icon="heater_pump" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
        <div
          class="frame secondary content-centered"
          :class="{active: heating === 'other'}"
          @click="heating = 'other'"
        >
          <h4>{{ $t("other") }}</h4>
          <SvgIcon icon="other" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("energy", ["type"]),
    heating: {
      get() {
        return this.$store.state.consumption.heating;
      },
      set(value) {
        this.$store.commit("consumption/setHeating", value);
      }
    }
  },
  created() {
    if (!this.heating) {
      if (this.type === "elec") this.heating = "other"
      else this.heating = "gas";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/HeaterType.vue